"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_hooks_1 = require("@apollo/react-hooks");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
const graphql_1 = require("../../../graphql");
exports.EmailCanvasToolbarDeleteEmailButton = () => {
    const { state: { sourceEmail }, } = hooks_1.useEmailCanvasContext();
    const [deleteEmail] = react_hooks_1.useMutation(graphql_1.softDeleteEmail, {
        onCompleted: ({ softDeleteEmail }) => {
            if (softDeleteEmail) {
                window.history.go(-1);
            }
        },
    });
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasToolbar.deleteEmail", onClick: () => {
            deleteEmail({
                variables: {
                    id: sourceEmail.id,
                },
            });
        }, osysIcon: "trash" }));
};
//# sourceMappingURL=DeleteEmailButton.js.map